module.exports = __webpack_public_path__ + "img/124.1.b023b536.jpg";